export const SENDING_REQUEST = 'PERMISSIONCATEGORIESFORM_SENDING_REQUEST';
export const CREATE_SUCCESS = 'PERMISSIONCATEGORIESFORM_CREATE_SUCCESS';
export const UPDATE_SUCCESS = 'PERMISSIONCATEGORIESFORM_UPDATE_SUCCESS';
export const FAILURE = 'PERMISSIONCATEGORIESFORM_FAILURE';
export const RESET_FORM = 'PERMISSIONCATEGORIESFORM_RESET_FORM';